import { lazy } from "react";

export { COMPANY_SETTINGS_PATH } from "./path";
export const CompanySettingsPage = lazy(() => import("./page"));
